.formItem {
  margin: 2em 0;
}

.titleWithButton {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  & span {
    flex: 1;
  }

  & button {
    margin-left: 0.5em;
  }
}
